import { Http } from "./http.init";
import { ResponseWrapper, ErrorWrapper } from "./util";
import axios from "axios";
export class BaseAbstractService {
  constructor() {
    if (this.constructor === BaseAbstractService) {
      throw new Error("FYI: Instance of Abstract class cannot be instantiated");
    }
  }
  static get baseUrl() {
    throw new Error("baseUrl getter not defined");
  }

  static get baseHeader() {
    return {};
  }
  /**
   * ------------------------------
   * @HELPERS
   * ------------------------------
   */

  static callApi(auth = true) {
    if (typeof this.baseHeader === "object") {
      for (const [k, v] of Object.entries(this.baseHeader)) {
        axios.defaults.headers.common[k] = v;
      }
    }
    return new Http({ auth, baseUrl: this.baseUrl });
  }

  static responseWrapper(...rest) {
    return new ResponseWrapper(...rest);
  }

  static errorWrapper(...rest) {
    return new ErrorWrapper(...rest);
  }

  /**
   * ------------------------------
   * @API_CALLS_PUBLIC
   * ------------------------------
   */
}
